import { CanDeactivateFn } from '@angular/router';

/**
 * Contrato da tela do lote para a saída com arquivo de retorno pendente.
 *
 * <p>A confirmação é MS010, com efeito colateral: arquivo anexado é descartado e
 * arquivo processado <b>reverte o processamento</b>. Não reutiliza
 * {@code alteracoesNaoSalvasGuard} — aquele guarda só pergunta, com o texto da MS024.</p>
 */
export interface ComSaidaPendenteDoLote {
  /**
   * `true` libera a navegação. Quando há arquivo e o lote ainda não foi concluído,
   * pergunta MS010 e, se confirmado, descarta ou reverte antes de devolver `true`.
   */
  confirmarSaidaDoLote(): boolean | Promise<boolean>;
}

/**
 * Cobre qualquer saída pelo Router (menu, breadcrumb, botão voltar do navegador,
 * "Ver folha", o próprio "Voltar"). O componente decide o caso: sem arquivo, anexado ou processado.
 */
export const saidaLoteGuard: CanDeactivateFn<ComSaidaPendenteDoLote> = (component) =>
  component?.confirmarSaidaDoLote() ?? true;
